/* @ngInject */

export default (Insurance, helperService, INSTANCE) => {
  /**
   * Get available insurance types.
   *
   * @returns {Array}
   */
  const getAvailableInsuranceTypes = () => Insurance.getAvailableInsuranceTypes();

  /**
   * Get insurance types.
   *
   * @param {Array} assets
   * @param {Array} assetCommitmentSchedules
   * @param {Object} workflow
   * @param {Boolean} isCommercial
   *
   * @returns {Array}
   */
  const getInsuranceTypes = ({
    assets,
    assetCommitmentSchedules,
    workflow,
    isAssetFinanceCommercial
  }) => {
    const insuranceTypes = getAvailableInsuranceTypes();
    for (let i = 0; i < insuranceTypes.length; i += 1) {
      if (i === 0) {
        insuranceTypes[
          i
        ].isDisabled = !helperService.hasAssetWithAssetTypeOwnerOccupiedOrInvestment({
          assets
        });
      } else if (i === 1 || i === 9) {
        insuranceTypes[i].isDisabled = !helperService.hasAssetWithAssetTypeVehicle(assets);
        if (!_.isEmpty(workflow) && workflow.isAssetFinance() && isAssetFinanceCommercial) {
          insuranceTypes[i].isDisabled = !helperService.hasAssetCommitmentSchedule(
            assetCommitmentSchedules
          );
        }
      } else {
        insuranceTypes[i].isDisabled = false;
      }
    }
    return insuranceTypes;
  };

  /**
   * Can see insurance type.
   *
   * @param {Object} insuranceType
   *
   * @returns {Boolean}
   */
  const canSeeInsuranceType = (insuranceType) => {
    const insuranceTypes = getAvailableInsuranceTypes();
    return INSTANCE.identification === 'GEM' || INSTANCE.identification === 'GNZ'
      ? insuranceType.name !== insuranceTypes[7].name &&
          insuranceType.name !== insuranceTypes[8].name &&
          insuranceType.name !== insuranceTypes[9].name
      : true;
  };

  /**
   * Add insurance to insurances array.
   *
   * @param {Array} insurances
   *
   * @returns {Number}
   */
  const insuranceAdd = (insurances, insuranceType) => {
    insurances.push(Insurance.blank(insuranceType));
    return insurances;
  };

  /**
   * Remove insurance from insurances array.
   *
   * @param {Array} insurances
   * @param {Number} index
   *
   * @returns {Array}
   */
  const insuranceDelete = (insurances, index) =>
    helperService.removeItemFromArray(insurances, index);

  return {
    getAvailableInsuranceTypes,
    getInsuranceTypes,
    canSeeInsuranceType,
    insuranceAdd,
    insuranceDelete
  };
};
